import React, { useRef, useState, useEffect, memo, useCallback, useMemo, isValidElement } from 'react';
import classnames from 'classnames';
import { renderToString } from 'react-dom/server';
import { TextProcess, TextProcessProps } from './index.d';
import { getClassNames } from './utils/common';
import { JS_COMPUTED_VALID_CSS_PROPERTIES, JS_COMPUTED_NUMBER_TO_PX_PROPERTIES } from './utils/constants';
// @ts-ignore
import { getFixedWidthText } from '@gp/utils/utils';

import './index.scss';

const TYPE: TextProcess['arrType'] = ['shadow', 'ellipsis'];

const DEFAULT_PROPS: TextProcessProps = {
  // text: 'In all the parting, I like it best see you tomorrow.Of all the blessings I prefer, as you wish. Sometimes you look at the wrong person, not because you are jealous, but because you are kind. You never know how strong you really are until being strong is the only choice you have. Never bend your head. Always hold it high. Look the world straight in the face. Life is alive, there is not much, only helpless. Life is a wonderful journey. Make it your journey and not someone else\'s.',
  text: '',
  type: 'shadow',
  isDefaultFold: true,
  unfoldButtonText: 'Show Less',
  foldButtonText: 'Show All',
  buttonBeforeSlot: null,
  lineHeight: 16,
  ellipsisLineClamp: 2,
  className: '',
  customStyle: {},
  isShowAllContent: false,
  isMustButton: false,
  isMustNoButton: false,
  shadowInitBoxShowH: 76,
  isShadowLayer: true,
  shadowLayerStyle: {},
  onClick: null,
  getIsFold: null,
  isJsComputed: false,
  textSize: 12,
  textClassName: '',
  textStyle: {},
  textEndIcon: null,
  extraWidth: 0,
  textElClassName: '',
  onTextClick: () => {},
};

function index(props: TextProcessProps) {
  const {
    text,
    type,
    isDefaultFold,
    unfoldButtonText,
    foldButtonText,
    buttonBeforeSlot,
    lineHeight,
    ellipsisLineClamp,
    className,
    customStyle,
    isShowAllContent,
    isMustButton,
    isMustNoButton,
    shadowInitBoxShowH,
    isShadowLayer,
    shadowLayerStyle,
    onClick,
    getIsFold,
    isJsComputed,
    textSize,
    textClassName,
    textStyle,
    textEndIcon,
    extraWidth,
    textElClassName,
    onTextClick,
  } = props;

  // 用于初始化需要特殊处理的地方
  const [initEntry, setInitEntry] = useState<boolean>(true);
  // 文案是否折叠
  const [isFold, setIsFold] = useState<boolean>(true);
  // 判断是否出现操作按钮
  const [isShowBtn, setIsShowBtn] = useState<boolean>(false);
  // 是否触发handleResize
  const [isViewResize, setIsViewResize] = useState<boolean>(false);
  // 上一次触发handleResize时的时间戳
  const [lastViewResizeTime, setLastViewResizeTime] = useState<number>(0);
  // 触发handleResize时启用的定时器
  const intervalTimer = useRef<any>(null);
  // 文案可视区域DOM
  const viewingArea = useRef<HTMLParagraphElement>(null);
  // 文案整体容器DOM
  const textArea = useRef<HTMLSpanElement>(null);
  const shadowShowH = useRef<number>(76);

  // 使用js来计算展示的文案时使用
  const [width, setWidth] = useState(0);
  const cssText = useMemo(() => {
    let cssText = '';
    if (
      textStyle &&
      Object.prototype.toString.call(textStyle) === '[object Object]' &&
      JSON?.stringify(textStyle) !== '{}'
    ) {
      const reg = new RegExp('[A-Z]', 'g');
      for (const styleKey in textStyle) {
        const realStyleKey = styleKey?.replaceAll(reg, (str: string) => `-${str?.toLowerCase()}`);
        const styleValue = (textStyle as any)?.[styleKey];
        if (JS_COMPUTED_VALID_CSS_PROPERTIES?.includes(realStyleKey)) {
          const flag = JS_COMPUTED_NUMBER_TO_PX_PROPERTIES?.includes(realStyleKey) && typeof styleValue === 'number';
          cssText += `${realStyleKey}:${styleValue}${flag ? 'px' : ''};`;
        }
      }
    }

    return cssText;
  }, [textStyle]);
  const computedList = useMemo(() => {
    let finalText = '';
    let isEllipsis = false;
    // 为了获取该组件的宽度，组件第一次render时按所有text文字显示
    if (width && isJsComputed) {
      const sumWidth = width * (ellipsisLineClamp as number);
      const span = document.createElement('span');
      span.style.cssText = 'position:absolute;visibility:hidden;';
      span.innerHTML = `${
        isValidElement(foldButtonText) ? renderToString(foldButtonText) : !!foldButtonText ? String(foldButtonText) : ''
      }`;
      viewingArea?.current ? viewingArea?.current?.appendChild(span) : document.body.appendChild(span);
      const buttonWidth = span.offsetWidth || 0; // 按钮占的宽度
      viewingArea?.current ? viewingArea?.current?.removeChild(span) : document.body.removeChild(span);
      const str = getFixedWidthText(
        text,
        width,
        sumWidth - (extraWidth as number),
        textSize,
        400,
        true,
        cssText,
        textClassName,
        viewingArea?.current,
      );
      // 如果返回有省略号，说明文字超出了范围
      isEllipsis = str?.endsWith('...');
      const noButtonSumWidth = sumWidth - buttonWidth;
      // 下面计算折叠与否及是否展示按钮情况下得到的最终文案内容
      if (isEllipsis) {
        // 需要展示按钮时
        if ((foldButtonText || isMustButton) && !isMustNoButton) {
          const str = getFixedWidthText(
            text,
            width,
            noButtonSumWidth - (extraWidth as number),
            textSize,
            400,
            true,
            cssText,
            textClassName,
            viewingArea?.current,
          );
          finalText = str;
        } else {
          finalText = str;
        }
      } else {
        // 需要展示按钮时
        if (foldButtonText && isMustButton && !isMustNoButton) {
          const str = getFixedWidthText(
            text,
            width,
            noButtonSumWidth - (extraWidth as number),
            textSize,
            400,
            true,
            cssText,
            textClassName,
            viewingArea?.current,
          );
          isEllipsis = str?.endsWith('...');
          finalText = isEllipsis ? str : text;
        } else {
          finalText = text;
        }
      }
    }
    if (isJsComputed) {
      setIsFold(isEllipsis);
      !isMustButton && !isMustNoButton && setIsShowBtn(isEllipsis);
      if (isMustButton) setIsShowBtn(true);
      if (isMustNoButton) setIsShowBtn(false);
    }

    return {
      finalText,
      isFold: isEllipsis,
    };
  }, [
    text,
    width,
    ellipsisLineClamp,
    foldButtonText,
    textSize,
    cssText,
    textClassName,
    isMustButton,
    isMustNoButton,
    isJsComputed,
    extraWidth,
  ]);

  const getIsOverflow = useCallback(() => {
    const childrens: any = textArea?.current?.childNodes;
    let childSumH = 0; // 所有子元素标签加起来的高度
    for (let i = 0; i < childrens?.length; i++) {
      const t = childrens?.[i];
      childSumH += t?.offsetHeight;
    }
    // @ts-ignore
    const shadowFlag = type === 'shadow' && textArea?.current?.offsetHeight > shadowShowH.current;
    // @ts-ignore
    const generalFlag = textArea?.current?.offsetHeight > viewingArea?.current?.clientHeight;

    let res;
    if (!!childSumH) {
      res = (shadowFlag && childSumH > shadowShowH.current) || generalFlag;
    } else {
      res = shadowFlag || generalFlag;
    }

    return res;
  }, []);

  const handleResize = useCallback(() => {
    if (isShowAllContent) return;

    setIsViewResize(true);
    setLastViewResizeTime(Date.now());
    if (isJsComputed && viewingArea?.current) {
      setWidth(viewingArea?.current?.getBoundingClientRect()?.width || 0);
    } else {
      const flag = getIsOverflow();
      !isMustButton && !isMustNoButton && setIsShowBtn(flag);
      setIsFold(flag);
    }
  }, [isJsComputed, isMustButton, isMustNoButton, isShowAllContent]);

  const handleClick = useCallback(() => {
    onClick ? onClick?.() : setIsFold(!isFold);
  }, [onClick, isFold]);

  const getButtonContent = useCallback(() => {
    return isFold ? foldButtonText : unfoldButtonText;
  }, [isFold, unfoldButtonText, foldButtonText]);

  // 一定不展示按钮时，折叠状态，textEndIcon有的话要展示出来
  const getTextFoldNoButtonEndIcon = () => {
    return (
      isMustNoButton &&
      isFold &&
      textEndIcon && (
        <span
          className={'click-btn'}
          style={{
            display: 'inline-block',
            lineHeight: `${lineHeight}px`,
          }}
        >
          {textEndIcon}
        </span>
      )
    );
  };

  // 初始化
  const init = () => {
    if (!TYPE.includes(type as TextProcess['type'])) {
      console.error('文案处理类型type不在可选范围！');
      return;
    }
    if (isShowAllContent) {
      isMustButton && setIsShowBtn(true);
      setIsFold(false);
      return;
    }
    shadowShowH.current = shadowInitBoxShowH as number;

    if (!isJsComputed) {
      if (getIsOverflow()) {
        setIsFold(isDefaultFold as boolean);
        setIsShowBtn(true);
      } else {
        setIsFold(false);
      }
    }

    if (isMustButton) setIsShowBtn(true);
    if (isMustNoButton) setIsShowBtn(false);
    if (isJsComputed && viewingArea?.current) setWidth(viewingArea?.current?.getBoundingClientRect()?.width || 0);
    setInitEntry(false);
  };

  // 初始化判断是否显示操作按钮
  useEffect(() => {
    init();

    // 页面缩放时判断是否显示操作按钮
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [text]);

  // 触发handleResize时，开启定时器，当不触发时关闭定时器
  useEffect(() => {
    if (isViewResize && !intervalTimer.current) {
      intervalTimer.current = setInterval(() => {
        if (Date.now() - lastViewResizeTime > 100) {
          setIsViewResize(false);
          clearInterval(intervalTimer.current);
          intervalTimer.current = null;
        }
      }, 100);
    }
  }, [isViewResize]);

  useEffect(() => {
    getIsFold?.(isFold, initEntry);
  }, [isFold, initEntry]);

  return (
    <section className={`dbg-common-p-content ${className}`} style={customStyle}>
      <p
        className={'all-text' + ' text-overflow-processor-off'}
        style={{ display: 'none' }}
        dangerouslySetInnerHTML={{ __html: text }}
      ></p>
      <p
        ref={viewingArea}
        className={getClassNames({
          'text-overflow-processor-on': true,
          'p-shadow-info': type === 'shadow',
          'p-ellipsis-info': type === 'ellipsis',
          'text-show-less': isFold && type !== 'shadow',
          'text-show-all': !isFold,
        })}
        style={{
          display: isJsComputed ? 'inline-block' : type === 'ellipsis' && isViewResize ? '-webkit-box' : '',
          WebkitLineClamp: ellipsisLineClamp,
          lineHeight: `${lineHeight}px`,
          textAlign: type === 'ellipsis' && isShowBtn && isFold && !isJsComputed ? 'justify' : 'inherit',
        }}
      >
        {type === 'shadow' && (
          <>
            <span
              ref={textArea}
              className={getClassNames({
                'dbg-text': true,
                'text-show-btn-box': isShowBtn,
                'text-show-all-box': !isFold,
              })}
              style={{ height: isFold && !isViewResize && !initEntry ? shadowInitBoxShowH : 'auto' }}
              dangerouslySetInnerHTML={{ __html: text }}
            ></span>
            {isShadowLayer && isShowBtn && isFold && (
              <span className={'shadow'} style={Object?.assign({ bottom: lineHeight }, shadowLayerStyle)}></span>
            )}
            <span
              className={'click-btn'}
              style={{
                display: isShowBtn ? 'inline-block' : 'none',
                lineHeight: `${lineHeight}px`,
              }}
            >
              <label onClick={handleClick}>{getButtonContent()}</label>
            </span>
          </>
        )}
        {type === 'ellipsis' ? (
          <>
            {/* 把按钮撑到下面的DOM */}
            {(isMustNoButton && !textEndIcon) || !isShowBtn || (
              <i className={'click-btn-before'} style={{ height: `calc(100% - ${lineHeight}px)` }}></i>
            )}
            <span
              className={'click-btn'}
              style={{
                display: isShowBtn ? 'inline-block' : 'none',
                lineHeight: `${lineHeight}px`,
              }}
            >
              {textEndIcon && isFold && textEndIcon}
              {buttonBeforeSlot || (isJsComputed ? null : <>&nbsp;</>)}
              <label onClick={handleClick}>{getButtonContent()}</label>
            </span>
            {/* 一定不展示按钮时，折叠状态，textEndIcon有的话要展示出来 */}
            {getTextFoldNoButtonEndIcon()}
            {/* <span className={'text'} ref={textArea} dangerouslySetInnerHTML={{ __html: (isJsComputed && isFold) ? computedList?.finalText || '' : text }}></span> */}
            <span className={classnames('text', textElClassName)} ref={textArea} onClick={onTextClick}>
              <span
                dangerouslySetInnerHTML={{ __html: isJsComputed && isFold ? computedList?.finalText || '' : text }}
              ></span>
              {textEndIcon && !isFold && textEndIcon}
            </span>
          </>
        ) : null}
      </p>
    </section>
  );
}

index.defaultProps = DEFAULT_PROPS;

export default memo(index);
